import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import classNames from "classnames";
import omit from "rc-util/lib/omit";
import * as React from "react";
import { ConfigContext } from "../ConfigProvider";
import Element from "./Element";
import { jsx as _jsx } from "react/jsx-runtime";
var SkeletonButton = function SkeletonButton(props) {
  var _classNames;
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    active = props.active,
    _props$block = props.block,
    block = _props$block === void 0 ? false : _props$block,
    _props$size = props.size,
    size = _props$size === void 0 ? "default" : _props$size;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("skeleton", customizePrefixCls);
  var otherProps = omit(props, ["prefixCls"]);
  var cls = classNames(prefixCls, "".concat(prefixCls, "-element"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-active"), active), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames), className);
  return /*#__PURE__*/_jsx("div", {
    className: cls,
    children: /*#__PURE__*/_jsx(Element, _objectSpread({
      prefixCls: "".concat(prefixCls, "-button"),
      size: size
    }, otherProps))
  });
};
export default SkeletonButton;